namespace GeniuzPOS.InitialData {
    export namespace PsConnectEdcPortService {
        export const baseUrl = 'InitialData/PsConnectEdcPort';

        export declare function Create(request: Serenity.SaveRequest<PsConnectEdcPortRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsConnectEdcPortRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsConnectEdcPortRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsConnectEdcPortRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsConnectEdcPort/Create",
            Update = "InitialData/PsConnectEdcPort/Update",
            Delete = "InitialData/PsConnectEdcPort/Delete",
            Retrieve = "InitialData/PsConnectEdcPort/Retrieve",
            List = "InitialData/PsConnectEdcPort/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsConnectEdcPortService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
